// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_DeletausuarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for deletaUsuario() /usuarios/deletaUsuario
 * Returns bool (true) on successful user deletion via auth-service.
 * Proxy to auth-service /admin/deletaUsuario/{username}.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_DeletausuarioResponseDados = boolean;

export type Usuarios_DeletausuarioResponse = ApiResponse<Usuarios_DeletausuarioResponseDados>;

registerResponseContract('Usuarios_DeletausuarioResponse', {})
